import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface Yearbooks {
  name: string;
  api_token: string;
}

export interface YearbooksListInfor {
  errors: unknown;
  yearbooks: Yearbooks;
  isAuthenticated: boolean;
}

@Module
export default class YearbooksModule
  extends VuexModule
  implements YearbooksListInfor
{
  errors = {};
  yearbooks = {} as Yearbooks;
  isAuthenticated = !!JwtService.getToken();

  get Yearbooks() {
    return this.yearbooksListData;
  }

  @Mutation
  [Mutations.YEARBOOKS_LIST_DATA](Yearbooks) {
    this.yearbooksListData = Yearbooks;
  }

  @Action
  [Actions.YEARBOOKS_LIST](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("/niengiam", payload)
        .then((data) => {
          this.context.commit(Mutations.YEARBOOKS_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.YEARBOOK_CREATE](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("niengiam/upsert", payload)
        .then((data) => {
          this.context.commit(Mutations.YEARBOOKS_LIST_DATA, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.YEARBOOK_UPDATE](payload) {
    const id = payload.get("id");
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.getDataDetail("/niengiam", "upsert", id, payload)
        .then((data) => {
          this.context.commit(Mutations.YEARBOOKS_LIST_DATA, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.YEARBOOK_DELETE](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.getDataDetail("/niengiam", payload, "delete", payload)
        .then((data) => {
          this.context.commit(Mutations.YEARBOOKS_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }
}
